import React, {memo} from 'react';
import './RestaurantInfo.less';
import {RestaurantIcon} from 'elements/restaurant-icon/RestaurantIcon';
import {ChainName} from 'elements/chain-name/ChainName';
import {LocationSelectTrigger} from '../location-select-trigger/LocationSelectTrigger';
import {MoreTrigger} from '../more-trigger/MoreTrigger';
import {DeliveryCaption} from '../delivery-caption/DeliveryCaption';
import {PickupCaption} from '../pickup-caption/PickupCaption';
import {SmileyReport} from "../smiley-report/SmileyReport";
import {OrderingTypes} from "new-constants/common.constants";

export const RestaurantInfo = memo((
	{
		iconSrc,
		name,
		currentLocationName,
		onLocationSelectClick,
		onMoreClick,
		currentOrderingType,
		isShowExpectedWait,
		deliveryExpectedWait,
		deliveryPrice,
		pickupExpectedWait,
		smileyReportLink,
	}) => {
	
	const expectedWait = currentOrderingType === OrderingTypes.delivery
		? (
			<div className="restaurant-info__delivery-time">
				<DeliveryCaption time={deliveryExpectedWait} price={deliveryPrice}/>
			</div>
		)
		: (
			<div className="restaurant-info__pickup-time">
				<PickupCaption time={pickupExpectedWait}/>
			</div>
		);
	
	return (
		<div className="restaurant-info">
			<div className="restaurant-info__top-container">
				{
					iconSrc && (
						<div className="restaurant-info__icon">
							<RestaurantIcon src={iconSrc}/>
						</div>
					)
				}
				<div className="restaurant-info__container1">
					<div className="restaurant-info__name">
						<ChainName text={name}/>
					</div>
					<div className="restaurant-info__container2">
						<div className="restaurant-info__location-select-trigger">
							<LocationSelectTrigger currentLocationName={currentLocationName} onClick={onLocationSelectClick}/>
						</div>
						<div className="restaurant-info__more">
							<MoreTrigger onClick={onMoreClick}/>
						</div>
					</div>
				</div>
			</div>
			<div className="restaurant-info__bottom-container">
				{
					isShowExpectedWait && expectedWait
				}
				{
					smileyReportLink && <SmileyReport link={smileyReportLink}/>
				}
			</div>
		</div>
	);
});
